import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePosition } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";

const useDeletePosition = (companyId: string, structureId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (positionId) =>
      deletePosition({ companyId, structureId, positionId }),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie usunięto stanowisko"), "success");
      queryClient.invalidateQueries({
        queryKey: ["positions-list", companyId, structureId],
      });
    },
    onError: () => {
      dynamicNotification(__("Nie udało się usunąć stanowiska"), "error");
    },
  });
};

export default useDeletePosition;
